module.exports = __webpack_public_path__ + "img/prod_info_mispos.3cf1647e.svg";